// styles.js
import styled from "styled-components";

export const Container = styled.div`
  padding: 100px 20px 60px;
  max-width: 1000px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  color: #cf0505;
  margin-bottom: 30px;
  text-align: center;
`;

export const FiltroLinha = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;

export const Select = styled.select`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

export const Input = styled.input`
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
`;

export const Button = styled.button`
  padding: 10px 16px;
  background-color: #003366;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;

  &:hover {
    background-color: #002244;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 40px 0 20px;
`;

export const Erro = styled.p`
  color: red;
  text-align: center;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 60px;

  th, td {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: left;
  }

  th {
    background-color: #eee;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
`;
